import { createBrowserRouter, Navigate } from 'react-router'
import { AppLayout } from '@/components/layout/app-layout'
import { ProtectedRoute } from '@/lib/protected-route'
import { AbusePage } from '@/pages/abuse'
import { AccountDetailPage } from '@/pages/account-detail'
import { AccountsPage } from '@/pages/accounts'
import { AdminUsersPage } from '@/pages/admin-users'
import { AlertsPage } from '@/pages/alerts'
import { AuditLogPage } from '@/pages/audit-log'
import { BillingPage } from '@/pages/billing'
import { BounceAnalyticsPage } from '@/pages/bounce-analytics'
import { BoxesPage } from '@/pages/boxes'
import { BugReportsPage } from '@/pages/bug-reports'
import { BuilderApplicationsPage } from '@/pages/builder-applications'
import { DeliverabilityPage } from '@/pages/deliverability'
import { DomainsPage } from '@/pages/domains'
import { EmailExplorerPage } from '@/pages/email-explorer'
import { EnginePage } from '@/pages/engine'
import { InfrastructurePage } from '@/pages/infrastructure'
import { IpsPage } from '@/pages/ips'
import { LoginPage } from '@/pages/login'
import { OverviewPage } from '@/pages/overview'
import { SettingsPage } from '@/pages/settings'
import { StagingPage } from '@/pages/staging'
import { StatusPage } from '@/pages/status'

export const router = createBrowserRouter([
  {
    path: '/login',
    element: <LoginPage />,
  },
  {
    element: (
      <ProtectedRoute>
        <AppLayout />
      </ProtectedRoute>
    ),
    children: [
      { index: true, element: <OverviewPage /> },
      { path: 'accounts', element: <AccountsPage /> },
      { path: 'accounts/:id', element: <AccountDetailPage /> },
      { path: 'emails', element: <EmailExplorerPage /> },
      { path: 'engine', element: <EnginePage /> },
      { path: 'boxes', element: <BoxesPage /> },
      { path: 'ips', element: <IpsPage /> },
      { path: 'domains', element: <DomainsPage /> },
      { path: 'deliverability', element: <DeliverabilityPage /> },
      { path: 'bounces', element: <BounceAnalyticsPage /> },
      { path: 'billing', element: <BillingPage /> },
      { path: 'abuse', element: <AbusePage /> },
      { path: 'builder-applications', element: <BuilderApplicationsPage /> },
      { path: 'alerts', element: <AlertsPage /> },
      { path: 'audit', element: <AuditLogPage /> },
      {
        path: 'admin/users',
        element: (
          <ProtectedRoute requireSuperAdmin>
            <AdminUsersPage />
          </ProtectedRoute>
        ),
      },
      { path: 'infrastructure', element: <InfrastructurePage /> },
      { path: 'staging', element: <StagingPage /> },
      { path: 'status', element: <StatusPage /> },
      { path: 'bug-reports', element: <BugReportsPage /> },
      { path: 'settings', element: <SettingsPage /> },
      { path: '*', element: <Navigate to="/" replace /> },
    ],
  },
])
